<template>
  <div class="index">
    <el-card class="index-container" shadow="never">
      <p class="index-container-title" style="padding: 0px">客户信息</p>
      <table border="" class="index-container-table">
        <tr>
          <td class="index-container-table-label">家长姓名</td>
          <td class="index-container-table-text">{{ detailData.name }}</td>
          <td class="index-container-table-label">会员名</td>
          <td class="index-container-table-text">{{ detailData.childName }}</td>
          <td class="index-container-table-label">手机号</td>
          <td class="index-container-table-text">{{ detailData.phone }}</td>
        </tr>
        <tr>
          <td class="index-container-table-label">会员姓名</td>
          <td class="index-container-table-text">{{ detailData.childName }}</td>
          <td class="index-container-table-label">月龄(月)</td>
          <td class="index-container-table-text">{{ detailData.monthC }}</td>
          <td class="index-container-table-label">宝贝类型</td>
          <td class="index-container-table-text">{{ detailData.childType==1?'婴儿':'幼儿' }}</td>
        </tr>
        <tr>
          <td class="index-container-table-label">录单人</td>
          <td class="index-container-table-text">
            {{ detailData.workerName }}
          </td>
          <td class="index-container-table-label">购卡时间</td>
          <td class="index-container-table-text">{{ detailData.payTime }}</td>
          <td class="index-container-table-label">购卡销售</td>
          <td class="index-container-table-text" v-for="(v , index) in detailData.marketNames" :key="index">
            {{ v }}

          </td>
        </tr>
        <tr>
          <td class="index-container-table-label">备注</td>
          <td class="index-container-table-text" colspan="5">
            {{ detailData.remark }}
          </td>
        </tr>
      </table>
    </el-card>
    <el-card class="index-container index-containerwp" shadow="never">
      <p class="index-container-title">购买记录</p>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="购卡" name="first"></el-tab-pane>
        <el-tab-pane label="续卡" name="second"></el-tab-pane>
      </el-tabs>
      <el-table
        :data="detailData.userBuyCardRecordVoList"
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="false"
        max-height="520"
        ref="tableData"
      >
        <el-table-column prop="cardName" label="购卡卡项"> </el-table-column>
        <el-table-column prop="payTime" label="购买课时" show-overflow-tooltip=""> </el-table-column>
        <el-table-column prop="totalLesssonCount" label="正价课时">
        </el-table-column>
        <el-table-column prop="totalGiveCount" label="赠送课时">
        </el-table-column>
        <el-table-column prop="givenPay" label="优惠金额"> </el-table-column>
        <el-table-column prop="realPay" label="应付"> </el-table-column>
        <el-table-column prop="totalPay" label="实付"> </el-table-column>
        <!-- <el-table-column prop="date" label="尾款"> </el-table-column>
        <el-table-column prop="date" label="尾款截止日期"> </el-table-column> -->
        <el-table-column prop="createTime" label="支付时间"> </el-table-column>
        <el-table-column prop="" label="有效期" show-overflow-tooltip="">
          <template slot-scope="{row}">
            {{row.cardStartTime}} ~ {{row.cardEndTime}}
          </template>
        </el-table-column>
        <el-table-column prop="marketNames" label="销售人">
          <template slot-scope="{ row }">
            {{ getMarketNames(row.marketNames) }}
          </template>
        </el-table-column>
        <el-table-column prop="inviteWorkerName" label="邀约人"> </el-table-column>
        <el-table-column prop="source" label="渠道"> </el-table-column>
      </el-table>
      <!-- <p class="index-container-title" style="margin: 30px 0px 20px;">收支流水记录</p>
      <el-table
        :data="tableDataL"
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="false"
        max-height="520"
        ref="tableDataL"
      >
        <el-table-column prop="date" label="交易时间"> </el-table-column>
        <el-table-column prop="date" label="收入金额"> </el-table-column>
        <el-table-column prop="date" label="流水类型"> </el-table-column>
        <el-table-column prop="date" label="支付方式"> </el-table-column>
        <el-table-column prop="date" label="支付时间"> </el-table-column>
        <el-table-column prop="date" label="备注"> </el-table-column>
      </el-table> -->
    </el-card>
  </div>
</template>

<script>
import { qlUserByCardDetailVoById } from "@/api/userByCard";
export default {
  props: {
    childId: [Number, String],
  },
  data() {
    return {
      activeName: "first",
      tableData: [],
      tableDataL: [],
      detailData: {},
    };
  },

  mounted() {
    this.axiosGetUserDetail(5);
  },

  methods: {
    async axiosGetUserDetail(val) {
      const response = await qlUserByCardDetailVoById({
        id: this.childId,
        idt:val
      });
      console.log(response, "response详情");
      if (response.code == 20000) {
        this.detailData = response.data;
      }
    },
    getMarketNames(val) {
      let str = "";
      if (val && val.length) {
        val.forEach((element) => {
          str += element + "、";
        });
        return str;
      } else {
        return str;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if(tab.name == "first"){
        this.axiosGetUserDetail(5);
      }else{
        this.axiosGetUserDetail(4);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  text-align: initial;
  &-container {
    background: #ffffff;
    border-radius: 8px;
    padding: 20px 25px 30px;
    margin-bottom: 20px;
    /deep/ .el-card__body {
      padding: 0px;
    }
    &-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #282d30;
    }
    &-table {
      border-collapse: collapse;
      border-color: #ededed;
      margin-top: 30px;
      tr {
        td {
          padding: 20px 30px;
        }
      }
      &-label {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0e6fb8;
        background: #cedef5;
        width: 110px;
      }
      &-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #74798c;
        width: 250px;
      }
    }
    /deep/ .el-tabs,
    &-title {
      padding: 0 30px;
    }
    /deep/ .el-tabs {
      margin-top: 20px;
    }
  }
  &-containerwp {
    padding-left: 0px;
    padding-right: 0px;
  }
}
/deep/ .el-table th.el-table__cell > .cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}
/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}
</style>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/orderDetails.vue